import { makeStyles } from '@material-ui/core/styles';

const useStyles = () => ({
  centered: {
    display: 'flex'
  }
});

export default makeStyles(useStyles);
